import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Switch } from "@/components/ui/switch";
import { CheckCircle, GearSix } from "@phosphor-icons/react";

export default function JobWizardFieldRequirementsDialog({
  open,
  onOpenChange,
  fields,
  requiredFields,
  onToggle,
  onSave,
  saving,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-2xl border-slate-200 bg-white text-slate-900"
        data-testid="job-wizard-field-rules-dialog"
      >
        <DialogHeader>
          <DialogTitle className="font-heading flex items-center gap-2 text-lg font-extrabold">
            <GearSix size={20} className="text-emerald-700" />
            Job wizard field rules
          </DialogTitle>
          <DialogDescription>
            Save which fields are compulsory for every future job. Existing jobs remain unchanged.
          </DialogDescription>
        </DialogHeader>
        <div className="max-h-[58vh] space-y-5 overflow-y-auto pr-1">
          {[0, 1, 2, 3, 4].map((stepIndex) => {
            const stepFields = fields.filter((field) => field.step === stepIndex);
            if (!stepFields.length) return null;
            return (
              <section key={stepIndex} data-testid={`job-field-rules-step-${stepIndex + 1}`}>
                <h3 className="border-b border-slate-200 pb-2 text-[10px] font-extrabold uppercase tracking-wider text-slate-500">
                  Step {stepIndex + 1}
                </h3>
                <div className="divide-y divide-slate-100">
                  {stepFields.map((field) => {
                    const required = requiredFields.includes(field.key);
                    return (
                      <label
                        key={field.key}
                        className="flex cursor-pointer items-center justify-between gap-4 py-2.5"
                      >
                        <span className="text-sm font-semibold text-slate-700">{field.label}</span>
                        <span className="flex items-center gap-2 text-xs text-slate-500">
                          <Switch
                            checked={required}
                            onCheckedChange={() => onToggle(field.key)}
                            className="data-[state=checked]:bg-emerald-600"
                            data-testid={`job-field-rule-${field.key}`}
                          />
                          <span className={required ? "font-bold text-emerald-700" : ""}>
                            {required ? "Compulsory" : "Optional"}
                          </span>
                        </span>
                      </label>
                    );
                  })}
                </div>
              </section>
            );
          })}
        </div>
        <div className="flex justify-end gap-2 border-t border-slate-200 pt-3">
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
            data-testid="job-field-rules-cancel"
          >
            Cancel
          </Button>
          <Button
            type="button"
            onClick={onSave}
            disabled={saving}
            className="bg-emerald-600 text-white hover:bg-emerald-700"
            data-testid="job-field-rules-save"
          >
            <CheckCircle size={15} weight="bold" />
            {saving ? "Saving…" : "Save field rules"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}